// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AwsEksNodeGroupTaintEffect } from './AwsEksNodeGroupTaintEffect';
import {
  AwsEksNodeGroupTaintEffectFromJSON,
  AwsEksNodeGroupTaintEffectFromJSONTyped,
  AwsEksNodeGroupTaintEffectToJSON,
  AwsEksNodeGroupTaintEffectToJSONTyped,
} from './AwsEksNodeGroupTaintEffect';

/**
 *
 * @export
 * @interface AwsEksNodeGroupTaint
 */
export interface AwsEksNodeGroupTaint {
  /**
   *
   * @type {AwsEksNodeGroupTaintEffect}
   * @memberof AwsEksNodeGroupTaint
   */
  effect?: AwsEksNodeGroupTaintEffect;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroupTaint
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroupTaint
   */
  value?: string;
}

/**
 * Check if a given object implements the AwsEksNodeGroupTaint interface.
 */
export function instanceOfAwsEksNodeGroupTaint(
  value: object,
): value is AwsEksNodeGroupTaint {
  return true;
}

export function AwsEksNodeGroupTaintFromJSON(json: any): AwsEksNodeGroupTaint {
  return AwsEksNodeGroupTaintFromJSONTyped(json, false);
}

export function AwsEksNodeGroupTaintFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroupTaint {
  if (json == null) {
    return json;
  }
  return {
    effect:
      json['effect'] == null
        ? undefined
        : AwsEksNodeGroupTaintEffectFromJSON(json['effect']),
    key: json['key'] == null ? undefined : json['key'],
    value: json['value'] == null ? undefined : json['value'],
  };
}

export function AwsEksNodeGroupTaintToJSON(json: any): AwsEksNodeGroupTaint {
  return AwsEksNodeGroupTaintToJSONTyped(json, false);
}

export function AwsEksNodeGroupTaintToJSONTyped(
  value?: AwsEksNodeGroupTaint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    effect: AwsEksNodeGroupTaintEffectToJSON(value['effect']),
    key: value['key'],
    value: value['value'],
  };
}
